import produce from "immer";
import React, { JSX } from "react";
import { Typography, Box, Checkbox, FormControlLabel } from "@mui/material";
import { vitals } from "../../Assessment/Vitals/VitalRow";
import { VitalSettings } from "../../../interfaces/ResourceCentreInterface";
import { ORDER_ACTION, OrderActionType, OrderButtons } from "./OpdSettings/AssessmentLabels";
import HtmlTooltip from "../../../components/HtmlTooltip";

interface PropType {
  vitalSettings: VitalSettings;
  setVitalSettings: React.Dispatch<React.SetStateAction<VitalSettings>>;
  vitalsOrder: Array<string>;
  setVitalsOrder: React.Dispatch<React.SetStateAction<Array<string>>>;
}

const AssessmentMedicalVitals = ({
  vitalSettings,
  setVitalSettings,
  vitalsOrder,
  setVitalsOrder
}: PropType): JSX.Element => {
  const handleOrdering = ({ action, label }: { action: OrderActionType; label: string }) => {
    const currentIndex = vitalsOrder.indexOf(label);
    let updatedIndex: number = -1;
    if (action === ORDER_ACTION.UP) {
      updatedIndex = currentIndex - 1;
    } else if (action === ORDER_ACTION.DOWN) {
      updatedIndex = currentIndex + 1;
    }
    if (updatedIndex >= 0) {
      setVitalsOrder(() =>
        produce(vitalsOrder, (draft) => {
          draft.splice(currentIndex, 1);
          draft.splice(updatedIndex, 0, label);
        })
      );
    }
  };

  return (
    <Box ml={2}>
      <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          Mange Vitals
        </Typography>
        <HtmlTooltip description="These vitals settings will be applied on Assessment And Medical modules." />
      </Box>
      <Box display="flex" mb={2} gap={2} justifyContent="space-between">
        <Typography width="260px" variant="body1" fontWeight="bold">
          Vitals
        </Typography>
        <Typography width="100px" variant="body1" fontWeight="bold">
          Ordering
        </Typography>
      </Box>
      <Box sx={{ height: "30rem", overflowY: "scroll", maxWidth: "41rem" }}>
        {vitalsOrder.map((vital, index) => (
          <Box
            display="flex"
            mb={2}
            gap={2}
            key={vital}
            justifyContent="space-between"
            alignItems="center"
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={Boolean(vitalSettings[vital])}
                  onChange={() => {
                    setVitalSettings({
                      ...vitalSettings,
                      [vital]: !vitalSettings[vital]
                    });
                  }}
                />
              }
              label={vitals.find(({ dbKey }) => dbKey === vital)?.label}
            />
            <OrderButtons
              isDisabled={{ up: index < 1, down: index > vitalsOrder.length - 2 }}
              onClick={{
                up: () => {
                  handleOrdering({
                    action: ORDER_ACTION.UP,
                    label: vital
                  });
                },
                down: () => {
                  handleOrdering({
                    action: ORDER_ACTION.DOWN,
                    label: vital
                  });
                }
              }}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AssessmentMedicalVitals;
